// extracted by mini-css-extract-plugin
export default {"primary-color":"#235594"};